import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { handleApiError } from '../../utils/route-guard/errorHandling';
import axios from 'axios'; // Assuming you're using Axios for consistency

export const fetchAskingPrices = createAsyncThunk(
  'askingPrices/fetchAskingPrices',
  async ({ url, token, postData }, { rejectWithValue }) => {
    try {
      // Using Axios for consistency with fetchProperty
      const response = await axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        data: postData // Axios uses `data` for the request body
      });

      // Directly return the data as Axios handles the response.ok check internally
      return response.data.data;
    } catch (error) {
      handleApiError(error); // Use the error handler
      // Align error message structure with fetchProperty
      const message = error.response ? error.response.data : error.message;
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  askingPricesList: null,
  status: 'idle',
  error: null
};

export const askingPricesSlice = createSlice({
  name: 'askingPrices',
  initialState,
  reducers: { resetAskingPrices: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAskingPrices.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAskingPrices.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.askingPricesList = action.payload;
      })
      .addCase(fetchAskingPrices.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export const { resetAskingPrices } = askingPricesSlice.actions;

export default askingPricesSlice.reducer;
